import React from 'react'
import TableSkeleton from '../loader/tableSkeleton';
import moment from 'moment';

const AttTable = ({ Data, isLoading }) => {
  // console.log("attendence data -->>>>>>", Data)
  const T_Head = ["S.No", "Name", "TimeIn", "TimeOut"]
  return (
    <div className="font-[sans-serif] py-4 overflow-x-auto">

      <table className="min-w-full bg-white dark:bg-darkgray">
        <thead className="bg-primaryPurple whitespace-nowrap">
          <tr>
            {T_Head.map((item, index) => (
              <th
                className="p-2 text-center text-lg font-bold text-white bg-primaryPurple dark:bg-lightgrey "
                key={index}
              >
                {item}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="whitespace-nowrap">
            <React.Fragment>
                  {
                  Data?.length === 0 || !Data ? 
                   <tr className="bg-gray-50 dark:bg-gray-800">
                <td colSpan={4}>
                  <div className="min-h-[200px] sm:min-h-[300px] lg:min-h-[400px]
                    flex flex-col items-center justify-center
                    text-center gap-2">
                    <p className="animate-pulse text-sm sm:text-base font-medium text-gray-800 dark:text-white">
                     Attendance data is currently unavailable
                    </p>
                    <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">
                      There are no attendance records to display at the moment.
                    </p>
                  </div>
                </td>
              </tr>
                  :
                  Data && Data?.map((employee, index) => {
                    let formatEntryTime = moment(employee?.ENTRYTIME).format("hh:mm A")
                    let formatLeavingTime = moment(employee?.LEAVEINGTIME).format("hh:mm A")
                    if (!formatEntryTime) return null;
                    return (
                      <tr
                        key={index}
                        className="text-center even:bg-blue-50 dark:even:bg-gray-700 dark:bg-gray-800 text-black dark:text-white "
                      >
                        <td className="p-2">{index + 1 }</td>
                        <td className="p-2">{employee?.NAME}</td>
                        <td className="p-2">{formatEntryTime}</td>
                        <td className="p-2">
                          {formatEntryTime &&
                          !employee.LEAVEINGTIME
                            ? "Still In"
                            : formatLeavingTime}
                        </td>
                      </tr>
                    );
                  })}
                </React.Fragment>
          
        </tbody>
      </table>
  </div>
  
  )
}

export default AttTable